export default {
	// api请求地址
	baseUrl: 'http://wenti.hzcsot.com',
	
	// 图片域名
	imgDomain: 'http://wenti.hzcsot.com',
	
	// 前端域名
	webDomain: 'http://wenti.hzcsot.com/web',
	
	// 腾讯地图key
	mpKey: 'IZQBZ-3UHEU-WTCVD-2464U-I5N4V-ZFFU3',
	
	// 客服
	webSocket: 'ws://wenti.hzcsot.com/wss',
	
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500
}